/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-22 13:12:16
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-12-27 15:52:46
 * @LastEditTime: 2020-08-07 18:32:17
 */
import { request } from "./api-require";
// const API_URL = "/oms-operation-service-gzk/v1";
const API_URL = "/oms-operation-service/v1";
export const getMonitorGunStatus = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/gun/status", data, config);
};
export const getMonitorPileGrid = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/pile/grid", data, config);
};
export const getMonitorPileData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/pile/data", data, config);
};
export const getMonitorGunInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/gun/info", data, config);
};
//获取站下全部桩及枪的数量
export const getMonitorTotalPileGun = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/total/pile_gun", data, config);
};
//查询枪SIM卡信号强度历史数据
export const getMonitorSimSignalStrengthHis = (data = {}, config = {}) => {
    return request(API_URL + "/monitor/gun/sim-signal-strength/his", data, config);
};
// 结算概览列表
export const getMerchantPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/merchant/page", data, config);
};
// 结算概览详情
export const getMerchantDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/detail", data, config);
};
// 结算概览详情 - 未结算完成详情
export const getMerchantQueryDate = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/query/date", data, config);
};
// 删除商户
export const delMerchant = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/merchant/del", data, config);
};
//
export const addMerchant = (data = {}, config = {}) => {
    return request(API_URL + "/opr/merchant/add", data, config);
};
export const updMerchant = (data = {}, config = {}) => {
    return request(API_URL + "/opr/merchant/upd", data, config);
};
export const getStaPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/page", data, config);
};
/**
 * 获取充电站详情
 */
export const getStaDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/detail", data, config);
};
// 新增站点
export const addSta = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/add", data, config);
};
// 修改站点
export const updSta = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/upd", data, config);
};
// 修改充电站状态
export const updStationStatus = (data = {}, config = {}) => {
    // config.method = "getDel";
    config.method = "postStr";
    return request(API_URL + "/opr/sta/upd_station_status", data, config);
};
/**
 * 查询费率模板信息
 */
export const getFeeInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/info", data, config);
};
/**
 * 查询站点下拉列表,站点id 站点名称
 */
export const getOprStaList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/list", data, config);
};
/**
 * 站点费率列表
 */
export const getOprStaFee = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/list/sta_fee", data, config);
};
/**
 *
 * @param data 删除站点费率
 * @param config
 */
export const delStaFee = (data = {}, config = {}) => {
    // config.method = "get";
    return request(API_URL + "/opr/sta/delete_fee", data, config);
};
/**
 *
 * @param data 查询站点电价列表
 * @param config
 */
export const getStaFeeDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/fee/detail", data, config);
};
/**
 * 查询充电站充电费率更换明细
 */
export const getStaFeeChargeDetails = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/fee/charge/trails", data, config);
};
/**
 * 充电站站预约率更换明细
 */
export const getStaFeeReservationDetails = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/fee/reservation/trails", data, config);
};
/**
 * 查询充电站占桩费率更换明细
 */
export const getStaFeeDelayDetails = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/fee/delay/trails", data, config);
};
/**
 * 查询充电费率详情
 */
export const getFeeDetailsAll = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/detail", data, config);
};
/**
 * 查询充电费率详情
 */
export const getFeeDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/get_fee_by_id", data, config);
};
export const bindStaFee = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/bind_fee", data, config);
};
// 站点已关联商户信息接口
export const getAssociatedSta = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/associated/sta", data, config);
};
// 站点取消关联商户接口
export const staUnbindMerchant = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/unbind/merchant", data, config);
};
// 站点关联商户接口
export const staBindMerchant = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/bind/merchant", data, config);
};
// 查询商户类型下拉列表
export const merchantListSimple = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/list_simple", data, config);
};
// 查询费率下拉列表,费率feePkId - 费率名称
export const getFeeList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/list", data, config);
};
// 查询预约费率下拉列表
export const getFeeReplaceList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/fee_replace", data, config);
};
// 查询商户下站点列表
export const getMchStaList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/merchant/list", data, config);
};
// 获取运营商配置信息
export const getConfigInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_congif_info", data, config);
};
// 获取登录账户信息
export const getLoginInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_login_info", data, config);
};
// 首页 - 资产
export const getHomeStatAssets = (data = {}, config = {}) => {
    return request(API_URL + "/stat/assets", data, config);
};
// 首页 - 充电数据
export const getHomeStatChargeCurve = (data = {}, config = {}) => {
    // config.method = "get";
    return request(API_URL + "/stat/charge_curve", data, config);
};
// 首页 - 充电枪状态
export const getHomeStatGunStatus = (data = {}, config = {}) => {
    return request(API_URL + "/stat/gun_status", data, config);
};
// 首页 - 创建的订单量
export const getHomeStatOrderCurve = (data = {}, config = {}) => {
    // config.method = "get";
    return request(API_URL + "/stat/order_curve", data, config);
};
// 首页 - 充电站昨日排名
export const getHomeStatRanking = (data = {}, config = {}) => {
    // config.method = "get";
    return request(API_URL + "/stat/sta_ranking", data, config);
};
// 首页 - 今日/昨日/累计数据 - 充电电量
export const getHomeStatisticsElec = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/elec", data, config);
};
// 首页 - 今日/昨日/累计数据 - 充电次数
export const getHomeStatisticsCharge = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/charge", data, config);
};
// 首页 - 今日/昨日/累计数据 - 实收数据看板
export const getHomeStatisticsTrans = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/trans", data, config);
};
// 首页 - 今日/昨日/累计数据 - 使用率数据看板
export const getHomeStatisticsUseRate = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/useRate", data, config);
};
// 首页 - 今日/昨日/累计数据 - 用户数
export const getHomeStatisticsUser = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/user", data, config);
};
// // 首页 - 今日充电电量
// export const getHomeStatTodayElec = (
//   data = {},
//   config: objAny = {}
// ): Promise<objAny> => {
//   return request(API_URL + "/stat/today_elec", data, config);
// };
// // 首页 - 今日营收
// export const getHomeStatTodayIncome = (
//   data = {},
//   config: objAny = {}
// ): Promise<objAny> => {
//   return request(API_URL + "/stat/today_income", data, config);
// };
// // 首页 - 今日订单量
// export const getHomeStatTodayOrders = (
//   data = {},
//   config: objAny = {}
// ): Promise<objAny> => {
//   return request(API_URL + "/stat/today_orders", data, config);
// };
// 首页 - 站点地图查询站点列表
export const getMapStaList = (data = {}, config = {}) => {
    // config.method = "get";
    return request(API_URL + "/map/sta/list", data, config);
};
// 首页 - 查看站点规模统计信息
export const getMapStaSize = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/size/statistics", data, config);
};
// 首页 - 查看站点规模配置信息
export const getStaSizeConfig = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/size/get", data, config);
};
// 首页 - 站点地图查看站点信息
export const getMapStaInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/map/sta/info", data, config);
};
// 获取运营商信息
export const getOprInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_opr_info", data, config);
};
// 获取运营商系统信息不用登陆
export const getOprLogo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_opr_Logo", data, config);
};
// GET查询运营商列表
export const getOprList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/list", data, config);
};
// 获取运营商系统头信息
export const getSysHeader = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sys_header", data, config);
};
// 获取运营商系统头信息
export const updCongifInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/upd_congif_info", data, config);
};
// 修改
export const updOprInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/upd_opr_info", data, config);
};
// 修改 充值及账户配置
export const updRechargeAccountInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/upd_recharge_config", data, config);
};
// 修改系统信息
export const updOprSystemInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/upd_opr_system_info", data, config);
};
//
// 获取充电站
export const getStaKvs = (data = {}, config = {}) => {
    return request(API_URL + "/stat/sta_kvs", data, config);
};
// 获取充电桩
export const getPileKvs = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/pile_kvs", data, config);
};
// 获取商户
export const getMerKvs = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/mer_kvs", data, config);
};
//获取会员和电卡统计
export const getCardStatistics = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/card/statistics", data, config);
};
//获取会员和电卡统计
export const getCardPage = (data = {}, config = {}) => {
    return request(API_URL + "/card/page", data, config);
};
//关联电卡
export const getCardBind = (data = {}, config = {}) => {
    return request(API_URL + "/card/bind", data, config);
};
//取消关联电卡
export const getCardUnbind = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/card/unbind", data, config);
};
//电卡详情
export const getCardDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/card/detail", data, config);
};
//获取企业会员统计数据
export const getEntUserStatistics = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/statistics", data, config);
};
//分页获取企业会员基本信息列表
export const getEntUserPage = (data = {}, config = {}) => {
    return request(API_URL + "/ent_user/page", data, config);
};
//获取所有企业会员基本信息列表
export const getAllEntUserPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/list", data, config);
};
//分页获取企业会员基本信息列表
export const getEntUserUpd = (data = {}, config = {}) => {
    return request(API_URL + "/ent_user/upd", data, config);
};
//分页获取企业会员基本信息列表
export const getEntUserNotExistSta = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/not_exist_sta", data, config);
};
//站点配置
export const getEntUserConfigSta = (data = {}, config = {}) => {
    return request(API_URL + "/ent_user/config_sta", data, config);
};
//已添加站点
export const getEntUserAlreadyExistSta = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/already_exist_sta", data, config);
};
//新增企业会员
export const getEntUserAdd = (data = {}, config = {}) => {
    return request(API_URL + "/ent_user/add", data, config);
};
//企业会员详情
export const getEntUserDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/details", data, config);
};
//分页获取企业用户组列表
export const getEntUserGroupList = (data = {}, config = {}) => {
    return request(API_URL + "/ent_sub_user/user_group/page", data, config);
};
//获取企业用户组下拉框
export const getEntUserGroupSelectList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_sub_user/user_group/list", data, config);
};
//新增企业用户组
export const addEntUserGroup = (data = {}, config = {}) => {
    return request(API_URL + "/ent_sub_user/user_group/add", data, config);
};
//修改企业用户组
export const updEntUserGroup = (data = {}, config = {}) => {
    return request(API_URL + "/ent_sub_user/user_group/upd", data, config);
};
//删除企业用户组
export const delEntUserGroup = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/ent_sub_user/user_group/del", data, config);
};
//查看用户组已绑定站点和可使用的站点
export const getEntUserGroupAlreadyExistSta = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_sub_user/user_group/already_exist_sta", data, config);
};
//查看用户组已绑定用户和可使用的用户
export const getEntUserGroupAlreadyExistUset = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_sub_user/user_group/already_exist_user", data, config);
};
//查询费率下拉列表,费率feePkId - 费率名称
export const getOprFeeList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/list", data, config);
};
//分页获取企业成员列表
export const getEntSubUserPage = (data = {}, config = {}) => {
    return request(API_URL + "/ent_sub_user/page", data, config);
};
//删企业成员列表
export const getEntSubUserDel = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/ent_sub_user/del", data, config);
};
//修改企业成员列表
export const getEntSubUserUpd = (data = {}, config = {}) => {
    return request(API_URL + "/ent_sub_user/upd", data, config);
};
//导入企业成员
export const importEntUser = (data = {}, config = {}) => {
    config.method = "formData";
    return request(API_URL + "/ent_sub_user/import/ent_user", data, config);
};
//企业会员操作历史记录
export const getOperHisList = (data = {}, config = {}) => {
    return request(API_URL + "/ent_user/oper_his/page", data, config);
};
//新增企业成员列表
export const getEntSubUserAdd = (data = {}, config = {}) => {
    return request(API_URL + "/ent_sub_user/add", data, config);
};
//获取企业用户已开放站点列表
export const getEntStaList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/opened/sta/list", data, config);
};
//首页弹出图表
export const getStatHourCurve = (data = {}, config = {}) => {
    return request(API_URL + "/stat/hour_curve", data, config);
};
//运营-统计数据
export const getOptData = (data = {}, config = {}) => {
    return request(API_URL + "/stat/opt/data", data, config);
};
//运营-图表数据
export const getOptChart = (data = {}, config = {}) => {
    return request(API_URL + "/stat/opt/chart", data, config);
};
//运营-表格数据
export const getOptGrid = (data = {}, config = {}) => {
    return request(API_URL + "/stat/opt/grid", data, config);
};
//运营-今日表格数据
export const getOptTodayChart = (data = {}, config = {}) => {
    return request(API_URL + "/stat/opt/today_chart", data, config);
};
//运营-今日统计数据
export const getOptTodayData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/opt/today_data", data, config);
};
// 一号多冲
export const getMultiChargeList = (data = {}, config = {}) => {
    return request(API_URL + "/opr/multicharge/page", data, config);
};
// 一号多冲 - 统计
export const getMultiChargeStatistics = (data = {}, config = {}) => {
    return request(API_URL + "/opr/multicharge/getStatistics", data, config);
};
// 一号多冲-审核
export const auditMultiCharge = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/multicharge/audit_multiCharge", data, config);
};
//
//运营-充电桩键值对集合
export const getStatPileKvs = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/pile_kvs", data, config);
};
//公告信息分页列表
export const getOprNoticeInfoList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/oprNoticeInfo/page", data, config);
};
//系统公告分页列表
export const getOprNoticeInfoSystemList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/notice/info/system/page", data, config);
};
//分页查询意见
export const getFeedBackList = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/feed/back/page", data, config);
};
//分页查询反馈消息
export const getFeedBackMsgList = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/feed/back/msg/page", data, config);
};
//客户消息分页查询
export const getFeedBackContentList = (data = {}, config = {}) => {
    return request(API_URL + "/opr/feed/back/page/content", data, config);
};
//反馈处理 (回复)
export const feedBackHandle = (data = {}, config = {}) => {
    return request(API_URL + "/opr/feed/back/handle", data, config);
};
//用户指南分页查询
export const getOprUserGuideArticle = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/guide/page", data, config);
};
//删除文章
export const delOprUserGuideArticle = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/guide/delete", data, config);
};
//新增文章
export const addOprUserGuideArticle = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/user/guide/add", data, config);
};
//修改文章
export const upOprUserGuideArticle = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/user/guide/update", data, config);
};
//目录名称列表
export const getOprUserGuideMenuAll = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/directory/management/list", data, config);
};
//目录管理分页查询
export const getOprUserGuideMenuList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/directory/management/page", data, config);
};
//新增目录
export const addOprUserGuideMenu = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/directory/management/add", data, config);
};
//更新目录
export const upOprUserGuideMenu = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/directory/management/update", data, config);
};
//删除目录
export const delOprUserGuideMenu = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/directory/management/delete", data, config);
};
//财务统计-表格数据
export const getStatFinanceGrid = (data = {}, config = {}) => {
    return request(API_URL + "/stat/finance/grid", data, config);
};
//账户月度收支图表数据
export const getaAcctViewChart = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/acct_view/month/chart", data, config);
};
//账户月度收支表格数据
export const getaAcctViewGrid = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/acct_view/month/grid", data, config);
};
//年份收入概览
export const getAcctViewSummery = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/acct_view/summery", data, config);
};
//运营-活跃人数表格数据
export const getOptActiveGrid = (data = {}, config = {}) => {
    return request(API_URL + "/stat/opt/active/grid", data, config);
};
//充电枪健值对集合
export const getStatGunKvs = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/gun_kvs", data, config);
};
//分页获取充电站报表信息
export const getOprReportStaPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/charge/sta", data, config);
};
//分页获取充电桩报表信息
export const getOprReportPilePage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/charge/pile", data, config);
};
//分页获取充电桩累计报表信息
export const getOprReportPileSum = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/charge/pile/sum", data, config);
};
//分页获取渠道报表信息
export const getOprReportChannelPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/channel", data, config);
};
//分页获取电卡报表信息
export const getOprReportChargePage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/charge/card", data, config);
};
//分页获取企业报表信息
export const getOprReportConnectPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/enterprise", data, config);
};
//分页查询公告内容
export const getNoticeList = (data = {}, config = {}) => {
    return request(API_URL + "/notice/info/page/notice", data, config);
};
//删除公告内容
export const delNotice = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/notice/info/delete/station/notice", data, config);
};
//添加站点公告内容
export const addNotice = (data = {}, config = {}) => {
    return request(API_URL + "/notice/info/add/station/notice", data, config);
};
//添加系统公告内容
export const addWxNotice = (data = {}, config = {}) => {
    return request(API_URL + "/notice/info/add/system/notice", data, config);
};
//删除公告内容
export const oprStaDel = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/sta/del", data, config);
};
//分页查询优惠券模板
export const getCouponList = (data = {}, config = {}) => {
    return request(API_URL + "/coupon/template/page", data, config);
};
//新增优惠券模板
export const addCoupon = (data = {}, config = {}) => {
    return request(API_URL + "/coupon/template/add", data, config);
};
//修改优惠券模板
export const updateCoupon = (data = {}, config = {}) => {
    return request(API_URL + "/coupon/template/update", data, config);
};
//优惠券模板详情
export const getCouponDetail = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/coupon/template/detail", data, config);
};
//审核优惠券
export const auditCoupon = (data = {}, config = {}) => {
    return request(API_URL + "/coupon/template/audit", data, config);
};
//审核优惠券
export const delCoupon = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/coupon/template/delete", data, config);
};
//优惠券及单次发放数量集合
export const getTemplateCouponList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/coupon/template/coupon/list", data, config);
};
//优惠券列表-- 发放赠送优惠券
export const issueFreeCoupon = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/issue/free_coupon", data, config);
};
//分页查询营销活动
export const getCampaign = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/page", data, config);
};
//新增营销活动
export const addCampaign = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/add", data, config);
};
//修改营销活动
export const updateCampaign = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/update", data, config);
};
//删除营销活动
export const delCampaign = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/campaign/delete", data, config);
};
//营销活动详情
export const getCampaignDetail = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/campaign/detail", data, config);
};
//审核营销活动
export const auditCampaign = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/audit", data, config);
};
//停用营销活动
export const stopCampaign = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/campaign/block/up", data, config);
};
//获取当前运营商所有站点集合
export const getCampaignStationList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/campaign/station/list", data, config);
};
//分页查询用户优惠券
export const getUserCoupon = (data = {}, config = {}) => {
    return request(API_URL + "/user/coupon/page", data, config);
};
//用户详情
export const getUserDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/card/baseDetail", data, config);
};
//查询用户关联的企业信息
export const getCardEnterprise = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/card/enterprise", data, config);
};
//站点提交审核
export const submitApplications = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/submit_applications", data, config);
};
//站点审核
export const auditApplications = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/audit_applications", data, config);
};
//维护记录
export const getStaMaintenanceRecord = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/maintenance_record", data, config);
};
//现场调试
export const fieldDebugging = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/field_debugging", data, config);
};
//费率审核
export const auditFeeApplications = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/audit_fee_applications", data, config);
};
//修改操作密码
export const modifyOperation = (data = {}, config = {}) => {
    return request(API_URL + "/opr/modify_operation", data, config);
};
//查询标签信息
export const getTagList = (data = {}, config = {}) => {
    // return request(API_URL + "/opr/tag/list", data, config);
    return request(API_URL + "/opr/tag/opr/page", data, config);
};
// //新增标签信息
// export const addTag = (data = {}, config: objAny = {}): Promise<objAny> => {
//   config.method = "postStr";
//   return request(API_URL + "/opr/tag/insert", data, config);
// };
// //删除标签信息
// export const delTag = (data = {}, config: objAny = {}): Promise<objAny> => {
//   config.method = "getDel";
//   return request(API_URL + "/opr/tag/delete", data, config);
// };
//新增活动调价
export const addPrice = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/add/price", data, config);
};
//修改活动调价
export const upPrice = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/update/price", data, config);
};
//活动调价详情
export const getPriceDetails = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/campaign/detail/price", data, config);
};
//导入用户手机号
export const importUserPhones = (data = {}, config = {}) => {
    config.method = "formData";
    return request(API_URL + "/campaign/import/user_phones", data, config);
};
//优惠券手动发放
export const manualIssued = (data = {}, config = {}) => {
    return request(API_URL + "/campaign/manual/issued", data, config);
};
//优惠券-手动发放详情
export const manualIssuedDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/campaign/detail/manual_issued", data, config);
};
//查询营销活动下拉框
export const getCampaignSelect = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/campaign/get", data, config);
};
//绑定的费率和站点信息
export const alreadyExistSta = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/ent_user/already_exist_sta", data, config);
};
//修改运营商开票信息配置
export const updConfigInvoiceInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/upd_config_invoice_info", data, config);
};
//获取运营商配置信息
export const getCongifInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_congif_info", data, config);
};
//获取发票分页
export const getOprInvoicePage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/invoice/page", data, config);
};
//新增发票
export const getOprInvoiceAdd = (data = {}, config = {}) => {
    return request(API_URL + "/opr/invoice/add", data, config);
};
//发票详情
export const getOprInvoiceDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/detail", data, config);
};
// 审核
export const getOprInvoiceAudit = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/audit", data, config);
};
// 开票
export const getOprInvoiceDraw = (data = {}, config = {}) => {
    return request(API_URL + "/opr/invoice/draw", data, config);
};
// 发票操作详情
export const getOprInvoiceOperationDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/operation/detail", data, config);
};
// 全局纵览--查询订单及订单量
export const getOverviewQuery = (data = {}, config = {}) => {
    return request(API_URL + "/opr/overview/query", data, config);
};
// 全局纵览--查询订单及订单量
export const getOverviewQueryDay = (data = {}, config = {}) => {
    return request(API_URL + "/opr/overview/query", data, config);
};
// 全局纵览--查询订单及订单量--周
export const getOverviewQueryWeek = (data = {}, config = {}) => {
    return request(API_URL + "/opr/overview/query/week", data, config);
};
// 全局纵览--查询订单及订单量--月
export const getOverviewQueryMonth = (data = {}, config = {}) => {
    return request(API_URL + "/opr/overview/query/month", data, config);
};
// 导入充电站数据,新增充电站
export const importSta = (data = {}, config = {}) => {
    config.method = "formData";
    config.timeout = 60 * 20 * 1000; // 设置超时时间
    return request(API_URL + "/opr/sta/import", data, config);
};
// 保存充电站导入数据
export const saveImportSta = (data = {}, config = {}) => {
    config.timeout = 60 * 2 * 1000; // 设置超时时间
    return request(API_URL + "/opr/sta/import/save", data, config);
};
// 运营-排名数据
export const getOptRanking = (data = {}, config = {}) => {
    return request(API_URL + "/stat/opt/ranking", data, config);
};
// 用户分析 -- 分析指标
export const getUserAnalysisBase = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/analysis/base", data, config);
};
// 用户分析 -- 分析趋势
export const getUserAnalysisTrend = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/analysis/trend", data, config);
};
// 用户分析 -- 充电策略分析
export const getUserAnalysisChargingStrategyAnalysis = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/analysis/charging_strategy_analysis", data, config);
};
// 用户分析 -- 启动方式分析
export const getUserAnalysisStartModeAnalysis = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/analysis/start_mode_analysis", data, config);
};
// 用户分析 -- 单次充电时长分布
export const getUserAnalysisSingleChargeDuration = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/analysis/single_charge_duration", data, config);
};
// 用户分析 -- 用户排行下载表格
export const getUserAnalysisExport = (data = {}, config = {}) => {
    return request(API_URL + "/user/analysis/export", data, config);
};
// 用户分析 -- 省级或市级用户占比查询
export const getUserAnalysisPercentageOfUsers = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/analysis/percentage_of_users", data, config);
};
// 用户分析 -- 用户排行
export const getUserAnalysisRranking = (data = {}, config = {}) => {
    return request(API_URL + "/user/analysis/user_ranking", data, config);
};
// 用户分析 -- 分页查询用户分析基础数据
export const getUserAnalysisList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/user/analysis/page", data, config);
};
// 获取用户等级列表
export const getUserVipList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/user/vip/list", data, config);
};
// 获取用户等级列表
export const getUserVipDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/user/vip/detail", data, config);
};
// 等级配置及用户会员购买价格详情
export const getUserVipUpdateStatus = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/user/vip/update_status", data, config);
};
// 新增等级配置及用户会员购买价格
export const addUserVip = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/vip/add", data, config);
};
// 获取用户等级图形数据
export const getUserVipGraphicData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/user/vip/get/graphic_data", data, config);
};
// 分页获取用户等级购买记录
export const getUserVipRecord = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/vip/page", data, config);
};
// 获取运营商会员配置信息
export const getUserVipAble = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/user/vip/config", data, config);
};
// 开启或关闭用户会员等级功能
export const saveUserVipAble = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/vip/able", data, config);
};
// 获取用户当前会员等级
export const getUserVipCurr = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/user/vip/curr", data, config);
};
// 分页获取用户等级购买记录
export const getUserVipPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/vip/page", data, config);
};
// 分页获取会员等级失效记录
export const getUserVipExpirePage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/vip/expire/page", data, config);
};
// 分页获取用户等级生命周期
export const getUserVipLifePage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/vip/life/page", data, config);
};
// 查询已产生积分汇总
export const getTotalPoints = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/points/campaign/get_total_points", data, config);
};
// 查询积分活动汇总
export const getSummarizing = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/points/campaign/get_summarizing", data, config);
};
// 查询积分活动排行
export const getPointsRank = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/points/campaign/get_rank", data, config);
};
// 分页获取积分活动列表
export const getPointsList = (data = {}, config = {}) => {
    return request(API_URL + "/points/campaign/page", data, config);
};
// 新增积分活动
export const addPoints = (data = {}, config = {}) => {
    return request(API_URL + "/points/campaign/add", data, config);
};
// 修改积分活动
export const upPoints = (data = {}, config = {}) => {
    return request(API_URL + "/points/campaign/upd", data, config);
};
// 删除积分活动
export const delPointsList = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/points/campaign/del", data, config);
};
// 停止积分活动
export const stopPoints = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/points/campaign/stop", data, config);
};
// 查询积分兑换汇总
export const getExchangeSummarizing = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/points/campaign/get_exchange_summarizing", data, config);
};
// 查询积分兑换排行
export const getExchangeRank = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/points/campaign/get_exchange_rank", data, config);
};
// 分页获取积分兑换记录
export const getPointsExchange = (data = {}, config = {}) => {
    return request(API_URL + "/points/campaign/get_points_exchange", data, config);
};
// 分页获取积分增长记录
export const getPointsGrow = (data = {}, config = {}) => {
    return request(API_URL + "/points/campaign/get_points_grow", data, config);
};
// 积分设置
export const savePointsSetting = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/points/setting/points", data, config);
};
// 平台积分调整
export const savePointsAdjust = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/points/adjust/points", data, config);
};
// 购买用户等级
export const purchaseUserVip = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/vip/purchase/user/vip", data, config);
};
// 购买用户等级(管理员)
export const purchaseUserVipAdmin = (data = {}, config = {}) => {
    return request(API_URL + "/opr/user/vip/adjust/user/vip", data, config);
};
// 获取会员等级比例数据
export const getUserVipRate = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/user/vip/get/user_vip_rate", data, config);
};
// 获取积分设置信息
export const getPointsSettingPoints = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/user/points/get/setting_points", data, config);
};
// 更新审核设置
export const getUpdateAuditSettings = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/update/audit_settings", data, config);
};
// 统计发票相关数据信息
export const getInvoiceInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/stat/invoice_info", data, config);
};
// 运营商查询待办事项详情
export const getOperBacklog = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/backlog/opr/detail", data, config);
};
// 大屏数据-营收数据
export const getBigRevenueData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/revenue/data", data, config);
};
// 大屏数据-电量趋势
export const getBigChargingData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/charging/data", data, config);
};
// 大屏数据-订单数据
export const getBigChargingOrderData = (data = {}, config = {}) => {
    config.method = "get";
    // return request(API_URL + "/big/screen/charge/order_data", data, config);
    return request(API_URL + "/big/screen/order/type/data", data, config);
};
// 大屏数据-充电时长
export const getBigChargingOrderSeconds = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/charging/seconds", data, config);
};
// 大屏数据-站点地图/电量热地地图/营收热力地图
export const getBigScreenStationMap = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/get/station_map", data, config);
};
// 大屏数据-站点营收排行
export const getBigScreenAnalysisStaRanking = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/analysis/sta/data_ranking", data, config);
};
// 大屏数据-用户充电策略分析
export const getBigScreenAnalysisUserChargingModel = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/analysis/user/charging_model", data, config);
};
// 大屏数据-用户启动方式分析
export const getBigScreenAnalysisUserStartMode = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/analysis/user/start_mode", data, config);
};
// 大屏数据-获取碳减排数据
export const getBigchargeCo2 = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/charge/co2", data, config);
};
// 大屏数据-获取汇总数据
export const getBigAggregateData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/get/aggregate/data", data, config);
};
// 大屏数据-获取今日数据
export const getBigTodayData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/get/today/data", data, config);
};
// 大屏数据-使用率与利用率趋势图
export const getEfficiencyData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/efficiency/data", data, config);
};
// 大屏数据-根据站点id获取站点数据
export const getBigDataByStation = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/get/Data/by_station", data, config);
};
// 大屏数据-获取用户数据
export const getBigUserData = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/big/screen/get/user_data", data, config);
};
// 查询某个站点使用的增值服务
export const getOperAccretionservice = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/accretion/service/get", data, config);
};
// 查询所有增值服务
export const getAllOperAccretionservice = (data = {}, config = {}) => {
    return request(API_URL + "/opr/accretion/service/list", data, config);
};
// 设置某个站点的增值服务
export const setStaAccretionService = (data = {}, config = {}) => {
    return request(API_URL + "/opr/accretion/service/set", data, config);
};
// 获取站点单个策略详情
export const getStaStrategyDetails = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/sta/strategy/details", data, config);
};
// 新增站点单个类型策略
export const addStaStrategy = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/strategy/add", data, config);
};
// 获取关注当前站点的系统信息
export const getStaRelation = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/sta/strategy/get/sta/relation", data, config);
};
// 修改充电站soc信息
export const updStaSoc = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/upd/soc", data, config);
};
// 读卡
export const readCard = (data = {}, config = {}) => {
    return request(API_URL + "/recharge_card/read_card", data, config);
};
// 开卡
export const openCard = (data = {}, config = {}) => {
    return request(API_URL + "/recharge_card/open_card", data, config);
};
// 获取加密运营商编码
export const getByMchIdCustomerId = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/recharge_card/customerId", data, config);
};
// 注销
export const cancelCard = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/recharge_card/cancel_card", data, config);
};
// 获取新开卡的卡号
export const getCardSerialNumber = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/recharge_card/get_card_serial_number", data, config);
};
// 电卡详情
export const getCardDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/recharge_card/detail", data, config);
};
// 分页获取充电站桩功率统计列表
export const getPilePowerStatList = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/pile/power/stat/page", data, config);
};
// 查询本运营商下商户统计信息
export const getMerchantStat = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/stat", data, config);
};
// 查询本运营商下商户统计信息
export const closeMerchant = (data = {}, config = {}) => {
    return request(API_URL + "/opr/merchant/disable", data, config);
};
// 运营商商户概览统计信息
export const getMerchanSstatic = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/static", data, config);
};
// 运营商商户概览列表
export const getMerchanSstaticList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/static/list", data, config);
};
// 查询商户各月结算概况看板信息（详情里）
export const getMerchanMonthInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/month/info", data, config);
};
// 查询商户各月结算概况（详情里）
export const getMerchanMonthList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/month/list", data, config);
};
// 代营商户报表
export const getMerchanReport = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/report", data, config);
};
// 分页查询批量更换费率计划
export const getStaFeeSchPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/fee/sch/page", data, config);
};
// 新增批量更换费率计划
export const addStaFeeSch = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/fee/sch/add", data, config);
};
// 删除批量更换费率计划
export const delStaFeeSch = (data = {}, config = {}) => {
    config.method = "del";
    return request(API_URL + "/opr/sta/fee/sch/del", data, config);
};
// 更新批量更换费率计划
export const updStaFeeSch = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/fee/sch/upd", data, config);
};
// 获取批量更换费率计划详情
export const getStaFeeSchDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/fee/sch/detail", data, config);
};
// 立即执行批量更换费率计划
export const execStaFeeSch = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/fee/sch/exec", data, config);
};
// 取消站点更换充电费率计划
export const cancelStaFeeSch = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/fee/sch/cancel", data, config);
};
// 通过运营商id获取所有费率列表
export const getFeeAvailableList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/available/list", data, config);
};
// 分页查询充电站费率追踪列表
export const getStaFeeTrailPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/fee/trail/page", data, config);
};
// 批量更换站点延时费率
export const allChangeDelay = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/fee/delay/replace", data, config);
};
// 分页查询商城商品
export const getMallProductPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/mall/product/page", data, config);
};
// 上下架商城商品
export const putMallProduct = (data = {}, config = {}) => {
    return request(API_URL + "/opr/mall/product/put/sale", data, config);
};
// 添加商城商品
export const addMallProduct = (data = {}, config = {}) => {
    return request(API_URL + "/opr/mall/product/save", data, config);
};
// 补减商城商品
export const upNumMallProduct = (data = {}, config = {}) => {
    return request(API_URL + "/opr/mall/product/batch/stock/update", data, config);
};
// 删除商品
export const delMallProduct = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/mall/product/delete", data, config);
};
// 根据商品id批量获取商品列表
export const getMallProductList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/mall/product/list", data, config);
};
// 运营商商城地址列表
export const getMallAddressPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/mall/address/config/list", data, config);
};
// 删除商城地址列表
export const delMallAddress = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/mall/address/config/delete", data, config);
};
// 根据id获取运营商商城地址列表
export const getMallAddressList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/mall/address/config/list/ids", data, config);
};
// 添加运营商商城地址列表
export const addMallAddress = (data = {}, config = {}) => {
    return request(API_URL + "/opr/mall/address/config/save", data, config);
};
// 启用/停用商城地址
export const upStatusMallAddress = (data = {}, config = {}) => {
    return request(API_URL + "/opr/mall/address/config/status/update", data, config);
};
// 获取运营商商城配置
export const getMallConfig = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/mall/config/get", data, config);
};
// 设置商城库存线
export const setMallConfigLimit = (data = {}, config = {}) => {
    return request(API_URL + "/opr/mall/config/limit", data, config);
};
// 设置商城是否开启
export const setMallConfigStatus = (data = {}, config = {}) => {
    return request(API_URL + "/opr/mall/config/status/update", data, config);
};
// 分页查询订单列表
export const getMallOrderList = (data = {}, config = {}) => {
    return request(API_URL + "/opr/mall/order/page", data, config);
};
// 获取订单详情
export const getMallOrderDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/mall/order/detail", data, config);
};
// 订单发货
export const deliveryMallOrder = (data = {}, config = {}) => {
    return request(API_URL + "/opr/mall/order/delivery", data, config);
};
// 订单收货
export const receiveMallOrder = (data = {}, config = {}) => {
    return request(API_URL + "/opr/mall/order/receive", data, config);
};
// 统计运营商商城订单信息
export const getMallOrderStat = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/mall/order/stat", data, config);
};
// 分页获取业务信息
export const getConsultList = (data = {}, config = {}) => {
    return request(API_URL + "/opr/consult/page", data, config);
};
// 修改业务信息
export const upConsult = (data = {}, config = {}) => {
    return request(API_URL + "/opr/consult/upd", data, config);
};
// 批量开通一卡多充
export const allOpenMulticharge = (data = {}, config = {}) => {
    return request(API_URL + "/opr/multicharge/batch/open", data, config);
};
// 批量关闭一卡多充
export const allCloseMulticharge = (data = {}, config = {}) => {
    return request(API_URL + "/opr/multicharge/batch/close", data, config);
};
// 分页统计上帝视角运营商设备及枪口状态
export const getMonitorOprPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/overview/opr/page", data, config);
};
// 分页统计运营商站点设备及枪口状态
export const getMonitorOprStaPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/opr/sta/page", data, config);
};
// 获取站点维度充电桩表格数据
export const getMonitorStaPileGrid = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/sta/pile/grid", data, config);
};
// 获取充电中和充电完成的桩
export const getMonitorStaPileChargingFull = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/monitor/sta/pile/charging_full", data, config);
};
// 页查询占桩费信息
export const getDelayPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/delay/page", data, config);
};
// 添加占桩费信息
export const addDelay = (data = {}, config = {}) => {
    return request(API_URL + "/opr/delay/add", data, config);
};
// 修改占桩费信息
export const updataDelay = (data = {}, config = {}) => {
    return request(API_URL + "/opr/delay/upd", data, config);
};
// 删除占桩费信息
export const delDelay = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/delay/del", data, config);
};
// 占桩费详情
export const getDelayDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/delay/get_fee_by_pile", data, config);
};
// 审核占桩费信息
export const auditDelay = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/delay/audit_fee_applications", data, config);
};
// 查询占桩费下拉
export const getDelayList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/delay/available/list", data, config);
};
// 查询占桩费关联的站点
export const getDelayBindSta = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/delay/get_bind_sta", data, config);
};
// 查询占桩费信息
export const getDelayInfo = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/delay/info", data, config);
};
// 分页查询充电费率下发明细
export const getStaFeeElecTracePage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/fee/elec/trace/page", data, config);
};
// 分页查询预约费率应用明细
export const getReservationApplyPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/reservation/apply/page", data, config);
};
// 分页查询费率应用明细
export const getStaFeeApplyPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/sta/fee/apply/page", data, config);
};
// 获取充电站统计信息
export const getReportChargeStatistics = (data = {}, config = {}) => {
    return request(API_URL + "/opr/report/charge/Statistics", data, config);
};
// 财务统计-表格数据
export const getStatFinancePage = (data = {}, config = {}) => {
    return request(API_URL + "/stat/finance/grid", data, config);
};
// 财务统计-看板信息
export const getStatFinanceStatistics = (data = {}, config = {}) => {
    return request(API_URL + "/stat/finance/statistics", data, config);
};
// 营收分析-数据概览
export const getIncomeAnalyseOverview = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/overview", data, config);
};
// 营收分析-总营收分析-总营收
export const getIncomeAnalyseTotal = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/total/income", data, config);
};
// 营收分析-总营收分析-应收占比
export const getIncomeAnalyseTotalProportion = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/total/proportion", data, config);
};
// 营收分析-总营收分析-实收占比
export const getIncomeAnalyseServiceProportion = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/service/proportion", data, config);
};
// 营收分析-总营收分析-优惠占比
export const getIncomeAnalyseDiscountProportion = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/discount/proportion", data, config);
};
// 营收分析-服务费营收分析-服务费营收
export const getIncomeAnalyseService = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/service/income", data, config);
};
// 营收分析-服务费营收分析-服务费尖峰平谷营收分析
export const getIncomeAnalyseServiceTime = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/service/time/income", data, config);
};
// 营收分析-服务费营收分析-服务费尖峰平谷占比
export const getIncomeAnalyseServiceTimeProportion = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/service/time/proportion", data, config);
};
// 营收分析-服电费营收分析-电费营收
export const getIncomeAnalyseElec = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/elec/income", data, config);
};
// 营收分析-服电费营收分析-电费尖峰平谷营收分析
export const getIncomeAnalyseElecTime = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/elec/time/income", data, config);
};
// 营收分析-服电费营收分析-电费尖峰平谷占比
export const getIncomeAnalyseElecTimeProportion = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/elec/time/proportion", data, config);
};
// 营收分析-占桩费营收分析-占桩费营收
export const getIncomeAnalyseDelay = (data = {}, config = {}) => {
    return request(API_URL + "/opr/income/analyse/delay/income", data, config);
};
// 站点排行 - 总营收排名Top10
export const getStaAnalysisRevenueTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/total/top10", data, config);
};
// 站点排行 - 总营收排名更多- 统计
export const getStaAnalysisRevenueMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/total/more/stat", data, config);
};
// 站点排行 - 总营收排名更多- 分页数据
export const getStaAnalysisRevenueMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/total/more/page", data, config);
};
// 站点排行 - 服务费营收排名top10
export const getStaAnalysisRevenueServiceTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/service/top10", data, config);
};
// 站点排行 - 服务费营收排名- 更多-统计
export const getStaAnalysisRevenueServiceMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/service/more/stat", data, config);
};
// 站点排行 - 服务费营收排名- 更多-分页数据
export const getStaAnalysisRevenueServiceMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/service/more/page", data, config);
};
// 站点排行 - 电费营收排名Top10
export const getStaAnalysisRevenueElecTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/elec/top10", data, config);
};
// 站点排行 - 电费营收 更多-统计
export const getStaAnalysisRevenueElecMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/elec/more/stat", data, config);
};
// 站点排行 - 电费营收排名- 更多-分页数据
export const getStaAnalysisRevenueElecMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/elec/more/page", data, config);
};
// 站点排行 - 占桩费营收排名Top10
export const getStaAnalysisRevenueDelayTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/delay/top10", data, config);
};
// 站点排行 - 占桩费营收 更多-统计
export const getStaAnalysisRevenueDelayMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/delay/more/stat", data, config);
};
// 站点排行 - 占桩费营收排名- 更多-分页数据
export const getStaAnalysisRevenueDelayMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/revenue/delay/more/page", data, config);
};
//  充电订单排名Top10
export const getStaAnalysisOrderTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/order/top10", data, config);
};
//  充电订单 更多-统计
export const getStaAnalysisOrderMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/order/more/stat", data, config);
};
//  充电订单排名- 更多-分页数据
export const getStaAnalysisOrderMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/order/more/page", data, config);
};
//  总电量 排名Top10
export const getStaAnalysisChargeTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/total/top10", data, config);
};
//  总电量  更多-统计
export const getStaAnalysisChargeMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/total/more/stat", data, config);
};
//  总电量 排名- 更多-分页数据
export const getStaAnalysisChargeMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/total/more/page", data, config);
};
//  尖充电量排名Top10
export const getStaAnalysisChargeSharpTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/sharp/top10", data, config);
};
//  尖充电量 更多-统计
export const getStaAnalysisChargeSharpMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/sharp/more/stat", data, config);
};
//  尖充电量排名- 更多-分页数据
export const getStaAnalysisChargeSharpMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/sharp/more/page", data, config);
};
//  峰充电量排名Top10
export const getStaAnalysisChargePeakTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/peak/top10", data, config);
};
//  峰充电量 更多-统计
export const getStaAnalysisChargePeakMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/peak/more/stat", data, config);
};
//  峰充电量排名- 更多-分页数据
export const getStaAnalysisChargePeakMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/peak/more/page", data, config);
};
//  平充电量排名Top10
export const getStaAnalysisChargeFlatTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/flat/top10", data, config);
};
//  平充电量 更多-统计
export const getStaAnalysisChargeFlatMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/flat/more/stat", data, config);
};
//  平充电量排名- 更多-分页数据
export const getStaAnalysisChargeFlatMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/flat/more/page", data, config);
};
//  谷充电量排名Top10
export const getStaAnalysisChargeValleyTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/valley/top10", data, config);
};
//  谷充电量 更多-统计
export const getStaAnalysisChargeValleyMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/valley/more/stat", data, config);
};
//  谷充电量排名- 更多-分页数据
export const getStaAnalysisChargeValleyMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/valley/more/page", data, config);
};
//  充电时长排名Top10
export const getStaAnalysisChargeDurationTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/duration/top10", data, config);
};
//  充电时长 更多-统计
export const getStaAnalysisChargeDurationMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/duration/more/stat", data, config);
};
//  充电时长排名- 更多-分页数据
export const getStaAnalysisChargeDurationMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/charge/duration/more/page", data, config);
};
//  使用率及利用率排名Top10
export const getStaAnalysisRatioTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/ratio/top10", data, config);
};
//  使用率 更多-统计
export const getStaAnalysisRatioMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/usage/more/stat", data, config);
};
//  使用率排名- 更多-分页数据
export const getStaAnalysisRatioMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/usage/more/page", data, config);
};
//  利用率 更多-统计
export const getStaAnalysisUtilMore = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/util/more/stat", data, config);
};
//  利用率排名- 更多-分页数据
export const getStaAnalysisUtilMorePage = (data = {}, config = {}) => {
    return request(API_URL + "/sta/analysis/util/more/page", data, config);
};
//  单站点分析- 列表
export const getOprStaAnalysisPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/station/analysis/page  ", data, config);
};
//  单站点分析- 详情
export const getOprStaAnalysisDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/station/analysis/detail", data, config);
};
//  使用分析- 数据概览
export const getOprUseAnalysisOverview = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/overview", data, config);
};
//  使用分析- 充电量分析-总充电量
export const getOprUseAnalysisTotalCharging = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/total/charging", data, config);
};
//  使用分析- 充电量分析-各时段充电量
export const getOprUseAnalysisTimeCharging = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/time/charging", data, config);
};
//  使用分析- 充电量分析-充电量尖峰平谷占比
export const getOprUseAnalysisTimeChargingProportion = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/time/charging/proportion", data, config);
};
//  使用分析- -充电订单分析-总订单量
export const getOprUseAnalysisTotalOrder = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/total/order", data, config);
};
//  使用分析- -充电订单分析-各类型订单量
export const getOprUseAnalysisOrderType = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/order/type", data, config);
};
//  使用分析- -充电订单 -各类型订单占比
export const getOprUseAnalysisOrderTypeProportion = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/order/type/proportion", data, config);
};
//  使用分析- 平均充电时长分析
export const getOprUseAnalysisChargingAvgDuration = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/charging/avg/duration", data, config);
};
//  使用分析- 活跃用户分析
export const getOprUseAnalysisActiveUserNum = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/active/user/num", data, config);
};
//  使用分析- 使用人数分析
export const getOprUseAnalysisUseUserNum = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/use/user/num", data, config);
};
//  使用分析- 用户增长
export const getOprUseAnalysisUserGrowth = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/use/user/growth", data, config);
};
//  使用分析- 充电使用率分析
export const getOprUseAnalysisUseRatio = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/use/ratio", data, config);
};
//  使用分析- 充电利用率分析
export const getOprUseAnalysisUseRate = (data = {}, config = {}) => {
    return request(API_URL + "/opr/use/analyse/use/rate", data, config);
};
//  用户分析- 查询个人用户详细数据
export const getOprUserAnalysisUserPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/users/analysis/user/page", data, config);
};
//  用户分析- 查询个人用户详细数据详情
export const getOprUserAnalysisUserDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/users/analysis/user/detail", data, config);
};
//  用户分析- 分页查询企业用户数据
export const getOprUserAnalysisEntPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/users/analysis/ent/page", data, config);
};
//  用户分析- 查询企业用户数据详情
export const getOprUserAnalysisEntDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/users/analysis/ent/detail", data, config);
};
//  用户分析- 分页查询非实名卡用户数据
export const getOprUserAnalysisCardPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/users/analysis/card/page", data, config);
};
//  用户分析- 查询非实名卡用户数据详情
export const getOprUserAnalysisCardDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/users/analysis/card/detail", data, config);
};
//  建设分析- 站点建设-统计数据
export const getConstructionOverviewStat = (data = {}, config = {}) => {
    return request(API_URL + "/construction/overview/stat", data, config);
};
//  建设分析- 站点建设-充电站建设分析图表
export const getConstructionOverviewSta = (data = {}, config = {}) => {
    return request(API_URL + "/construction/overview/sta", data, config);
};
//  建设分析- 站点建设-桩建设分析
export const getConstructionOverviewPile = (data = {}, config = {}) => {
    return request(API_URL + "/construction/overview/pile", data, config);
};
//  建设分析- 站点建设-枪建设分析
export const getConstructionOverviewGun = (data = {}, config = {}) => {
    return request(API_URL + "/construction/overview/gun", data, config);
};
//  建设分析- 站点建设-功率建设分析
export const getConstructionOverviewPower = (data = {}, config = {}) => {
    return request(API_URL + "/construction/overview/power", data, config);
};
//  建设分析- 站点建设排行
export const getConstructionPage = (data = {}, config = {}) => {
    return request(API_URL + "/construction/page", data, config);
};
//  建设分析- 统计数据
export const getConstructionStat = (data = {}, config = {}) => {
    return request(API_URL + "/construction/stat", data, config);
};
//  建设分析- 充电桩/枪/功率排名Top10
export const getConstructionTop10 = (data = {}, config = {}) => {
    return request(API_URL + "/construction/top10", data, config);
};
//  离线卡- 营收概览
export const getOfflineCardincomeOverview = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/income/overview/overview", data, config);
};
//  离线卡- 总营收分析-总营收
export const getOfflineCardincomeOverviewTotal = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/income/overview/total/income", data, config);
};
//  离线卡- 总营收分析-营收占比
export const getOfflineCardincomeOverviewTotalProportion = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/income/overview/total/income/proportion", data, config);
};
//  离线卡- 服务费营收分析-服务费营收
export const getOfflineCardincomeOverviewService = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/income/overview/service/income", data, config);
};
//  离线卡- 服务费营收分析-各时段服务费营收
export const getOfflineCardincomeOverviewTimeService = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/income/overview/time/service/income", data, config);
};
//  离线卡- 服务费营收分析-各时段服务费营收占比
export const getOfflineCardincomeOverviewTimeServiceProportion = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/income/overview/time/service/income/proportion", data, config);
};
//  离线卡- 电费营收分析-电费营收
export const getOfflineCardincomeOverviewElec = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/income/overview/elec/income", data, config);
};
//  离线卡- 电费营收分析-电费营收
export const getOfflineCardincomeOverviewElecTime = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/income/overview/elec/service/income", data, config);
};
//  离线卡- 电费营收分析-电费营收
export const getOfflineCardincomeOverviewElecTimeProportion = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/income/overview/elec/service/income/proportion", data, config);
};
//  离线卡- 使用总览-充电总览
export const getOfflineCardUseOverview = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/overview", data, config);
};
//  离线卡- 使用总览-充电量分析
export const getOfflineCardUseOverviewCharge = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/charge", data, config);
};
//  离线卡- 使用总览-充电量分析-各类型充电用户占比
export const getOfflineCardUseOverviewChargeProportion = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/charge/proportion", data, config);
};
//  离线卡- 使用总览-充电量分析-各时段充电量
export const getOfflineCardUseOverviewTimeCharge = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/time/charge", data, config);
};
//  离线卡- 使用总览-充电量分析-时段（各类型充电用户占比）
export const getOfflineCardUseOverviewTimeChargepProportion = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/time/charge/proportion", data, config);
};
//  离线卡- 使用总览-充电订单量分析-总充电订单量分析
export const getOfflineCardUseOverviewTotalOrder = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/total/order", data, config);
};
//  离线卡- 使用总览-充电订单量分析-各类型订单充电量
export const getOfflineCardUseOverviewTypeOrder = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/type/order", data, config);
};
//  离线卡- 使用总览-充电订单量分析-各类型订单充电量占比
export const getOfflineCardUseOverviewTypeOrderProportion = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/type/order/proportion", data, config);
};
//  离线卡- 使用总览-平均充电时长分析-平均充电时长
export const getOfflineCardUseOverviewAvgTime = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/avg/time", data, config);
};
//  离线卡- 使用总览-平均充电时长分析-平均充电时长占比
export const getOfflineCardUseOverviewAvgTimeProportion = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/avg/time/proportion", data, config);
};
//  离线卡- 使用总览-充电次数分析-充电次数
export const getOfflineCardUseOverviewOrderNum = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/order/num", data, config);
};
//  离线卡- 使用总览-充电次数分析-各类型充电次数占比
export const getOfflineCardUseOverviewOrderNumProportion = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/overview/order/num/proportion", data, config);
};
//  离线卡- 使用分析 -离线充电总览
export const getOfflineCardUseAnalyse = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/analyse/overview", data, config);
};
//  离线卡- 使用分析 -离线充电量分析
export const getOfflineCardUseAnalyseCharge = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/analyse/charge", data, config);
};
//  离线卡- 使用分析 -各时段充电占比
export const getOfflineCardUseAnalyseChargeProportion = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/analyse/charge/proportion", data, config);
};
//  离线卡- 使用分析 -离线充电量分析
export const getOfflineCardUseAnalyseTotalOrder = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/analyse/total/order", data, config);
};
//  离线卡- 使用分析 -平均充电时长
export const getOfflineCardUseAnalyseAvgTime = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/analyse/avg/time", data, config);
};
//  离线卡- 使用分析 -充电次数
export const getOfflineCardUseAnalyseOrderNum = (data = {}, config = {}) => {
    return request(API_URL + "/offline/card/use/analyse/order/num", data, config);
};
//  用户分析 - 用户营收概览 - 统计
export const getUserIncomeOverview = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/overview", data, config);
};
//  用户分析 - 总营收分析 - 总营收
export const getUserIncomeTotalIncome = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/total/income", data, config);
};
//  用户分析 - 总营收分析 - 应收占比
export const getUserIncomeTotalProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/total/proportion", data, config);
};
//  用户分析 - 总营收分析 - 实收占比
export const getUserIncomeTransProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/trans/proportion", data, config);
};
//  用户分析 - 总营收分析 - 优惠占比
export const getUserIncomeDiscountProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/discount/proportion", data, config);
};
//  用户分析 - 服务费营收分析 - 服务费营收
export const getUserIncomeServiceIncome = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/service/income", data, config);
};
//  用户分析 - 服务费营收分析 - 服务费尖峰平谷营收分析
export const getUserIncomeServiceIncomeTime = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/service/time/income", data, config);
};
//  用户分析 - 服务费营收分析 - 服务费尖峰平谷占比
export const getUserIncomeServiceIncomeTimeProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/service/time/proportion", data, config);
};
//  用户分析 - 服务费营收分析 - 电费营收
export const getUserIncomeElecIncome = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/elec/income", data, config);
};
//  用户分析 - 服务费营收分析 - 电费尖峰平谷营收分析
export const getUserIncomeElecIncomeTime = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/elec/time/income", data, config);
};
//  用户分析 - 服务费营收分析 - 电费尖峰平谷占比
export const getUserIncomeElecIncomeTimeProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/elec/time/proportion", data, config);
};
//  用户分析 - 服务费营收分析 - 占桩费营收
export const getUserIncomeDelayIncome = (data = {}, config = {}) => {
    return request(API_URL + "/user/income/delay/income", data, config);
};
//  用户分析 - 用户使用 - 用户使用总览
export const getUserUseOverview = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/overview", data, config);
};
//  用户分析 - 用户使用 - 总充电量
export const getUserUseOverviewTotalCharging = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/total/charging", data, config);
};
//  用户分析 - 用户使用 - 总充电量-占比
export const getUserUseOverviewTotalChargingProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/total/charging/proportion", data, config);
};
//  用户分析 - 用户使用 - 各时段充电量
export const getUserUseOverviewChargingTime = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/time/charging", data, config);
};
//  用户分析 - 用户使用 - 各时段充电量占比
export const getUserUseOverviewChargingTimeProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/time/charging/proportion", data, config);
};
//  用户分析 - 用户使用 - 平均充电时长
export const getUserUseOverviewChargingAvgDuration = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/charging/avg/duration", data, config);
};
//  用户分析 - 用户使用 - 平均充电时长
export const getUserUseOverviewChargingAvgDurationProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/charging/avg/duration/proportion", data, config);
};
//  用户分析 - 用户使用 - 充电次数
export const getUserUseOverviewChargingOrderType = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/order/type", data, config);
};
//  用户分析 - 用户使用 - 充电次数占比
export const getUserUseOverviewChargingOrderTypeProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/order/type/proportion", data, config);
};
//  用户分析 - 用户使用 - 活跃人数
export const getUserUseOverviewActiveUser = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/active/user/num", data, config);
};
//  用户分析 - 用户使用 - 活跃人数占比
export const getUserUseOverviewActiveUserProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/active/user/num/proportion", data, config);
};
//  用户分析 - 用户使用 - 使用人数
export const getUserUseOverviewUseUser = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/use/user/num", data, config);
};
//  用户分析 - 用户使用 - 使用人数占比
export const getUserUseOverviewUseUserProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview/use/user/num/proportion", data, config);
};
//  使用分析  - 用户使用总览
export const getUserUseOverviewType = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/overview", data, config);
};
//  使用分析  - 总充电量
export const getUserUseTotalCharging = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/total/charging", data, config);
};
//  使用分析  - 总充电量占比
export const getUserUseTotalChargingProportion = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/total/charging/proportion", data, config);
};
//  使用分析  - 订单量
export const getUserUseOrderNum = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/order/num", data, config);
};
//  使用分析  - 平均充电时长
export const getUserUseChargingAvgDuration = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/charging/avg/duration", data, config);
};
//  使用分析  - 充电次数
export const getUserUseOrderType = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/order/type", data, config);
};
//  使用分析  - 活跃人数
export const getUserUseActiveUser = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/active/user/num", data, config);
};
//  使用分析  - 使用人数
export const getUserUseUseUser = (data = {}, config = {}) => {
    return request(API_URL + "/user/use/use/user/num", data, config);
};
//  用户分析  - 用户排名 - 查询用户排名概览
export const getUserRankOverview = (data = {}, config = {}) => {
    return request(API_URL + "/user/rank/overview", data, config);
};
//  用户分析  - 用户排名 - 查询个人用户营收排名概览（总营收+服务费营收+电费营收+占桩费营收）
export const getUserIncomePersonRank = (data = {}, config = {}) => {
    return request(API_URL + "/user/rank/income/person/rank", data, config);
};
//  用户分析  - 用户排名 - 查询个人用户使用排名概览（充电量+充电次数+充电时长）
export const getUserRankUsePersonRank = (data = {}, config = {}) => {
    return request(API_URL + "/user/rank/use/person/rank", data, config);
};
//  用户分析  - 用户排名 - 查询企业营收排名概览（总营收+服务费营收+电费营收+占桩费营收）
export const getUserRankIncomeEnterpriseRank = (data = {}, config = {}) => {
    return request(API_URL + "/user/rank/income/enterprise/rank", data, config);
};
//  用户分析  - 用户排名 - 查询企业用户使用排名概览（充电量+充电次数+充电时长）
export const getUserRankUseEnterpriseRank = (data = {}, config = {}) => {
    return request(API_URL + "/user/rank/use/enterprise/rank", data, config);
};
//  用户分析  - 用户排名 - 查询电卡营收排名概览（总营收+服务费营收+电费营收+占桩费营收）
export const getUserRankIncomeCardRank = (data = {}, config = {}) => {
    return request(API_URL + "/user/rank/income/card/rank", data, config);
};
//  用户分析  - 用户排名 - 查询非实名在线卡用户使用排名概览（充电量+充电次数+充电时长）
export const getUserRankuseCardRank = (data = {}, config = {}) => {
    return request(API_URL + "/user/rank/use/card/rank", data, config);
};
// 有序充电 - 分页查询有序充电策略
export const getOrdingalStrategyPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/ordinal/strategy/page", data, config);
};
// 有序充电 - 有序充电策略下拉列表
export const getOrdingalStrategyList = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/ordinal/strategy/list", data, config);
};
// 有序充电 - 新增有序充电策略
export const addOrdingalStrategy = (data = {}, config = {}) => {
    return request(API_URL + "/opr/ordinal/strategy/add", data, config);
};
// 有序充电 - 修改有序充电策略
export const updataOrdingalStrategy = (data = {}, config = {}) => {
    return request(API_URL + "/opr/ordinal/strategy/upd", data, config);
};
// 有序充电 - 删除有序充电策略
export const delOrdingalStrategy = (data = {}, config = {}) => {
    return request(API_URL + "/opr/ordinal/strategy/del", data, config);
};
// 有序充电 - 查看使用的站点
export const getOrdingalStrategyUsePage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/ordinal/strategy/use/page", data, config);
};
// 有序充电 - 站点 - 查询站点应用的有序充电策略
export const getStaOrdingalStrategy = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/ordinal/strategy/sta", data, config);
};
// 有序充电 - 站点 - 修改站点应用的有序充电策略
export const bindStaOrdingalStrategy = (data = {}, config = {}) => {
    return request(API_URL + "/opr/ordinal/strategy/bind", data, config);
};
// 有序充电 - 站点 - 解绑站点应用的有序充电策略
export const unbindStaOrdingalStrategy = (data = {}, config = {}) => {
    return request(API_URL + "/opr/ordinal/strategy/unbind", data, config);
};
// 有序充电 - 站点 - 分组列表
export const getOrdinalGroupList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/ordinal/group/list", data, config);
};
// 有序充电 - 站点 - 分组新增
export const addOrdinalGroup = (data = {}, config = {}) => {
    return request(API_URL + "/opr/ordinal/group/add", data, config);
};
// 有序充电 - 站点 - 分组修改
export const updateOrdinalGroup = (data = {}, config = {}) => {
    return request(API_URL + "/opr/ordinal/group/update", data, config);
};
// 有序充电 - 站点 - 分组删除
export const ordinalGroupDel = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/ordinal/group/del", data, config);
};
// 有序充电 - 站点 - 分组 - 获取在线桩信息
export const getOrdinalGroupListPile = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/ordinal/group/list/pile", data, config);
};
// 有序充电 - 站点 - 分组 提交/开启
export const submitOrdinalGroup = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/ordinal/group/submit", data, config);
};
// 有序充电 - 站点 - 分组 分组配置提示信息
export const getOrdinalGroupPrompt = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/ordinal/group/get/prompt", data, config);
};
// 预约费率 - 分页查询计费信息
export const getReservationFeePage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/fee/page", data, config);
};
// 预约费率 - 新增
export const addReservationFee = (data = {}, config = {}) => {
    return request(API_URL + "/opr/reservation/fee/add", data, config);
};
// 预约费率 - 修改
export const updReservationFee = (data = {}, config = {}) => {
    return request(API_URL + "/opr/reservation/fee/upd", data, config);
};
// 预约费率 - 删除
export const delReservationFee = (data = {}, config = {}) => {
    config.method = "getDel";
    return request(API_URL + "/opr/reservation/fee/del", data, config);
};
// 预约费率 - 使用站点
export const getReservationBindPage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/fee/bind/page", data, config);
};
// 预约费率 - 查询费率下拉列表
export const getReservationFeeList = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/fee/list", data, config);
};
// 预约费率 - 查询费率详情
export const getReservationFeeDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/fee/info", data, config);
};
// 预约费率 - 绑定站点
export const bindReservationFee = (data = {}, config = {}) => {
    return request(API_URL + "/opr/reservation/fee/bind", data, config);
};
// 预约费率 - 解绑站点
export const unbindReservationFee = (data = {}, config = {}) => {
    return request(API_URL + "/opr/reservation/fee/unbind", data, config);
};
// 获取预约充电配置
export const getReservationConfig = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/config/info", data, config);
};
// 保存预约充电配置
export const saveReservationConfig = (data = {}, config = {}) => {
    return request(API_URL + "/opr/reservation/config/save", data, config);
};
//分页获取预约充电订单
export const getReservationPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/reservation/page", data, config);
};
//审核预约充电订单申诉
export const auditReservationAppeal = (data = {}, config = {}) => {
    return request(API_URL + "/opr/reservation/appeal/audit", data, config);
};
//预约充电订单申诉详情
export const getReservationAppealDetails = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/appeal/detail", data, config);
};
//统计预约充电订单
export const getReservationsStat = (data = {}, config = {}) => {
    return request(API_URL + "/opr/reservation/stat", data, config);
};
//获取预约充电订单详情
export const getReservationsDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/detail", data, config);
};
//获取预约充电订单计费详情
export const getReservationsBillingDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/billing/detail", data, config);
};
//查询预约单生命周期
export const getReservationsRrderLife = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/order/life", data, config);
};
//查询订单归属信息
export const getOrderBelong = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/order/belong", data, config);
};
//查询 搜索条件用的省市区
export const getSearchFindAreaList = (data = {}, config = {}) => {
    return request(API_URL + "/stat/search/findAreaList", data, config);
};
// 获取运营商分成信息
export const getSettlementInfo = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/get_settlement_info", data, config);
};
// 获取运营商发票抬头列表
export const getInvoiceTitle = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/invoice/get/opr_invoice_title", data, config);
};
// 添加发票抬头列表
export const addUpdInvoiceTitle = (data = {}, config = {}) => {
    return request(API_URL + "/opr/invoice/add/update_invoice_title", data, config);
};
// 获取发票详情
export const getInvoiceTitleDetail = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/detail/update_invoice_title", data, config);
};
// 删除发票抬头信息
export const deleteInvoiceTitle = (data = {}, config = {}) => {
    return request(API_URL + "/opr/invoice/delete/update_invoice_title", data, config);
};
// 新增发票信息
export const addInvoice = (data = {}, config = {}) => {
    return request(API_URL + "/opr/invoice/add/invoice_sms", data, config);
};
// 获取当月已修改结算方式次数
export const getMchModifiedCount = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/merchant/settlement_rule/modified_count", data, config);
};
//审核发票
export const auditOprInvoice = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/audit", data, config);
};
//发票审核信息
export const getOprInvoiceOperation = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/invoice/operation/detail", data, config);
};
//获取会员黑名单统计信息
export const getCardBlacklistStatistics = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/card/blacklist/stat", data, config);
};
//查询费率操作记录
export const getFeeTracePage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/trace/page", data, config);
};
//移入黑名单
export const addCardBlacklisting = (data = {}, config = {}) => {
    return request(API_URL + "/card/blacklist/in", data, config);
};
//移出黑名单
export const delCardBlacklisting = (data = {}, config = {}) => {
    return request(API_URL + "/card/blacklist/out", data, config);
};
//停用电卡
export const stopRechargeCard = (data = {}, config = {}) => {
    return request(API_URL + "/recharge_card/disuse", data, config);
};
//启用电卡
export const startRechargeCard = (data = {}, config = {}) => {
    return request(API_URL + "/recharge_card/reuse", data, config);
};
//取消费率更换
export const cancelFeeUpd = (data = {}, config = {}) => {
    return request(API_URL + "/opr/fee/upd/cancel", data, config);
};
//修改充电站 充电是否要车牌号
export const updOprStaLic = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/upd/lic", data, config);
};
//微信 - 特约商户进件（新增）
export const saveSpecialMer = (data = {}, config = {}) => {
    return request(API_URL + "/special/mer/save", data, config);
};
//微信 - 特约商户进件（提交申请单）
export const submitSpecialMer = (data = {}, config = {}) => {
    return request(API_URL + "/special/mer/submit", data, config);
};
//微信 - 图片上传接口
export const specialMerUploadImage = (data = {}, config = {}) => {
    return request(API_URL + "/special/mer/upload_image", data, config);
};
//查询运营商注册信息
export const getSpecialMer = (data = {}, config = {}) => {
    return request(API_URL + "/special/mer/query", data, config);
};
//修改运营商注册信息
export const updateSpecialMer = (data = {}, config = {}) => {
    return request(API_URL + "/special/mer/update", data, config);
};
//查询微信商户申请单的状态
export const getSpecialMerByApplymentId = (data = {}, config = {}) => {
    return request(API_URL + "/special/mer/queryByApplymentId", data, config);
};
//获取客户到期提醒配置
export const getOprCustomerMaturityWithdrawalConfig = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/customer/maturity/withdrawal/config/info", data, config);
};
//保存客户到期提醒配置
export const saveOprCustomerMaturityWithdrawalConfig = (data = {}, config = {}) => {
    return request(API_URL + "/opr/customer/maturity/withdrawal/config/save", data, config);
};
//分页查询企业费率和互联互通费率
export const getOprFeeDerivedPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/fee/derived/page", data, config);
};
//列表查询企业/互联互通费率关联站点
export const getOprFeeDerivedBindSta = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/derived/bound/sta/list", data, config);
};
//分页查询充电费率关联的站点
export const getOprFeeBindSta = (data = {}, config = {}) => {
    return request(API_URL + "/opr/fee/bound/sta/page", data, config);
};
//分页查询已关联预约费率站点总览
export const getReservationFeeBindStaPage = (data = {}, config = {}) => {
    config.method = "postStr";
    return request(API_URL + "/opr/reservation/fee/bind/sta/page", data, config);
};
//修改或新增运营商配置信息
export const updChargeSettleConfigInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/upd_charge_settle_config_info", data, config);
};
//修改SOC总体策略配置
export const updOprSocConfig = (data = {}, config = {}) => {
    return request(API_URL + "/opr/upd_opr_soc_config", data, config);
};
//运营中心 - 查询充电收入统计
export const getStatStatisticsAmount = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/amount", data, config);
};
//运营中心 - 查询充电订单统计
export const getStatStatisticsOrder = (data = {}, config = {}) => {
    return request(API_URL + "/stat/statistics/order", data, config);
};
//运营中心 - 查询费率统计统计
export const getStatStatisticsFee = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/statistics/fee", data, config);
};
//运营中心 - 查询积分活动统计
export const getStatStatisticsIntegral = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/statistics/integral", data, config);
};
//运营中心 - 查询营销活动统计
export const getStatStatisticsMarketing = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/statistics/marketing", data, config);
};
//运营中心 - 查询商城管理统计
export const getStatStatisticsMall = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/statistics/mall", data, config);
};
//运营中心 - 查询商城订单统计
export const getStatStatisticsMallOrder = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/statistics/mallOrder", data, config);
};
//运营中心 - 查询消息中心统计
export const getStatStatisticsMessage = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/stat/statistics/message", data, config);
};
//商户 - 分页获取商户规则日志列表
export const getMerchantRuleLogPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/merchant/rule/log/page", data, config);
};
//商户 中心- 使用数据统计
export const getMchStatisticsCharge = (data = {}, config = {}) => {
    return request(API_URL + "/stat/mch/statistics/charge", data, config);
};
//分页获取黑名单用户列表
export const getBlacklistPage = (data = {}, config = {}) => {
    return request(API_URL + "/card/blacklist/page", data, config);
};
//分页获取黑名单用户限制站点列表
export const getBlacklistRestrictSites = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/card/blacklist/sta/list", data, config);
};
//更新黑名单用户信息
export const getUpdateBlacklistInfo = (data = {}, config = {}) => {
    return request(API_URL + "/card/blacklist/upd", data, config);
};
//获取服务商信息
export const getOperatorInfo = (data = {}, config = {}) => {
    return request(API_URL + "/opr/problem/feed/back/list-config", data, config);
};
//分页获取问题反馈列表
export const getProblemFeedbackPage = (data = {}, config = {}) => {
    return request(API_URL + "/opr/problem/feed/back/page", data, config);
};
//新增反馈
export const getAddFeedback = (data = {}, config = {}) => {
    return request(API_URL + "/opr/problem/feed/back/save-feed-back", data, config);
};
//修改反馈
export const getUpdateFeedback = (data = {}, config = {}) => {
    return request(API_URL + "/opr/problem/feed/back/update-feed-back", data, config);
};
//删除反馈
export const getDeleteFeedback = (data = {}, config = {}) => {
    return request(API_URL + "/opr/problem/feed/back/delete-feed-back", data, config);
};
//查看问题反馈详情
export const getReplyDetail = (data = {}, config = {}) => {
    return request(API_URL + "/opr/problem/feed/back/detail", data, config);
};
//站点管理资产概览- 充电站统计
export const getOprAssetStatisticsSta = (data = {}, config = {}) => {
    return request(API_URL + "/opr/sta/state/statistics", data, config);
};
//商户概览-使用数据统计
export const getMchStatisticsUsage = (data = {}, config = {}) => {
    return request(API_URL + "/merchant/overview/using_data", data, config);
};
//商户概览-结算信息统计
export const getMchStatisticsBalance = (data = {}, config = {}) => {
    return request(API_URL + "/merchant/overview/settlement", data, config);
};
//商户概览-分成信息统计
export const getMchStatisticsShare = (data = {}, config = {}) => {
    return request(API_URL + "/merchant/overview/divided_info", data, config);
};
//商户概览-金额变化数据统计
export const getMchStatisticsMoney = (data = {}, config = {}) => {
    return request(API_URL + "/merchant/overview/amount_data", data, config);
};
//商户概览-商户信息数据统计
export const getMchStatisticsMchInfo = (data = {}, config = {}) => {
    return request(API_URL + "/merchant/overview/merchant_info", data, config);
};
//商户概览-发票信息数据统计
export const getMchStatisticsInvoice = (data = {}, config = {}) => {
    return request(API_URL + "/merchant/overview/invoice_info", data, config);
};
// 添加占桩费信息
export const addDelayAfter = (data = {}, config = {}) => {
    return request("/oms-operation-service/v1/opr/delay/add", data, config);
};
// 修改占桩费信息
export const updataDelayAfter = (data = {}, config = {}) => {
    return request("/oms-operation-service/v1/opr/delay/upd", data, config);
};
// 查询占桩费信息
export const getDelayInfoAfter = (data = {}, config = {}) => {
    config.method = "postStr";
    return request("/oms-operation-service/v1/opr/delay/info", data, config);
};
//获取会员和电卡统计
export const getUserCardPage = (data = {}, config = {}) => {
    return request("/oms-operation-service/v1/card/page", data, config);
};
/**
 * 资产中心- 充电桩统计
 */
export const getOprAssetStatisticsPile = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/asset/statistics/pile", data, config);
};
/*
 * 批量取消待下发费率的站点
 */
export const getCancleStation = (data = {}, config = {}) => {
    return request(API_URL + "/opr/fee/batch/cancel/sta", data, config);
};
/**
 * 取消待修改生效的费率
 */
export const getCancleFee = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/fee/cancel/upd", data, config);
};
/**
 * 预约费率修改记录
 */
export const getFeeUpdateRecord = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/reservation/fee/page/reservation_fee/record", data, config);
};
/**
 * 占桩费率修改记录
 */
export const getDelayFeeUpdateRecord = (data = {}, config = {}) => {
    config.method = "get";
    return request(API_URL + "/opr/delay/page/delay_fee/update_record", data, config);
};
/**
 * 分页查询策略操作记录
 */
export const getStrategyLog = (data = {}, config = {}) => {
    return request(API_URL + "/opr/ordinal/strategy/op/log", data, config);
};
